export interface CustomRegistrationFieldDTO {
  id: string;
  tournamentCategoryMappingId: string;
  fieldName: string;
  fieldKey: string;
  fieldType: FieldType;
  isRequired: boolean;
  isEncrypted: boolean;
  placeholder?: string | null;
  helpText?: string | null;
  displayOrder: number;
  minLength?: number | null;
  maxLength?: number | null;
  minValue?: number | null;
  maxValue?: number | null;
  validationPattern?: string | null;
  validationMessage?: string | null;
  isActive: boolean;
  createdAt: string;
}

export type FieldType = "string" | "number" | "date" | "email" | "phone" | "textarea";

export const FieldTypeLabels: Record<FieldType, string> = {
  string: "Text",
  number: "Number",
  date: "Date",
  email: "Email",
  phone: "Phone",
  textarea: "Text Area",
};

export interface CreateCustomRegistrationFieldDTO {
  fieldName: string;
  fieldKey: string;
  fieldType: FieldType;
  isRequired?: boolean;
  isEncrypted?: boolean;
  placeholder?: string;
  helpText?: string;
  displayOrder?: number;
  minLength?: number;
  maxLength?: number;
  minValue?: number;
  maxValue?: number;
  validationPattern?: string;
  validationMessage?: string;
}

export interface UpdateCustomRegistrationFieldDTO {
  fieldName?: string;
  fieldType?: FieldType;
  isRequired?: boolean;
  isEncrypted?: boolean;
  placeholder?: string;
  helpText?: string;
  displayOrder?: number;
  minLength?: number;
  maxLength?: number;
  minValue?: number;
  maxValue?: number;
  validationPattern?: string;
  validationMessage?: string;
  isActive?: boolean;
}

export interface CustomRegistrationFieldValueDTO {
  id: string;
  customRegistrationFieldId: string;
  fieldKey: string;
  fieldName: string;
  fieldType: FieldType;
  teamMemberId: string;
  value?: string;
  isEncrypted: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface SubmitCustomFieldValueDTO {
  customRegistrationFieldId: string;
  value?: string;
}

export interface SubmitCustomFieldValuesDTO {
  teamMemberId: string;
  fieldValues: SubmitCustomFieldValueDTO[];
}

export interface UpdateCustomFieldValueDTO {
  value?: string;
}

export interface TeamMemberCustomFieldsDTO {
  teamMemberId: string;
  playerName: string;
  fieldValues: CustomRegistrationFieldValueDTO[];
}

export interface TournamentCategoryCustomFieldsDTO {
  tournamentCategoryMappingId: string;
  categoryName: string;
  fields: CustomRegistrationFieldDTO[];
}
